var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41819 8.61875L10.3619 3.675C10.4786 3.55833 10.6147 3.5 10.7703 3.5C10.9258 3.5 11.0619 3.55833 11.1786 3.675C11.2953 3.79167 11.3536 3.93031 11.3536 4.09092C11.3536 4.25153 11.2953 4.38997 11.1786 4.50625L5.82652 9.87292C5.70985 9.98958 5.57374 10.0479 5.41819 10.0479C5.26263 10.0479 5.12652 9.98958 5.00985 9.87292L2.50152 7.36458C2.38485 7.24792 2.32885 7.10947 2.33352 6.94925C2.33819 6.78903 2.39905 6.65039 2.5161 6.53333C2.63316 6.41628 2.7718 6.35794 2.93202 6.35833C3.09224 6.35872 3.23069 6.41706 3.34735 6.53333L5.41819 8.61875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c82be676916009dc1849b2e50516b04e.svg";
export { ForwardRef as ReactComponent };